import api from './client.js'

export const wikiAPI = {
  list:   ()      => api.get('/wiki/articles'),
  get:    (slug)  => api.get(`/wiki/articles/${slug}`),
  create: (data)  => api.post('/wiki/articles', data),
  update: (slug, data) => api.patch(`/wiki/articles/${slug}`, data),
  remove: (slug)  => api.delete(`/wiki/articles/${slug}`),
}
